import { axiosJSONInstance } from '@/config';
import {
  ContactsResponse,
  ContactRequest,
  responseContactByUid,
  ContactImportPreviewResponse,
  ContactImportCommitResponse,
} from '@/types';

// Fetch Contacts (paginated)
export const fetchContacts = async (
  page = 1,
  perPage = 20,
  search?: string,
  regionUid?: string,
): Promise<ContactsResponse> => {
  const params = new URLSearchParams({
    page: page.toString(),
    perpage: perPage.toString(),
  });
  if (search) params.append('search', search);
  if (regionUid) params.append('filter_region_uid', regionUid);

  const response = await axiosJSONInstance.get(`/merchants/contacts?${params.toString()}`);
  return response.data;
};

// Create Contact
export const createContact = async (data: ContactRequest): Promise<ContactsResponse> => {
  const response = await axiosJSONInstance.post(`/merchants/contacts`, data);
  return response.data;
};

// Fetch Contact By ID
export const fetchContactById = async (id: string): Promise<responseContactByUid> => {
  const response = await axiosJSONInstance.get(`/merchants/contacts/${id}`);
  return response.data;
};

// Update Contact By ID
export const updateContactById = async (
  id: string,
  data: ContactRequest,
): Promise<ContactsResponse> => {
  const response = await axiosJSONInstance.patch(`/merchants/contacts/${id}`, data);
  return response.data;
};

// Delete Contact By ID
export const deleteContactById = async (id: string): Promise<ContactsResponse> => {
  const response = await axiosJSONInstance.delete(`/merchants/contacts/${id}`);
  return response.data;
};

// Bulk Delete Contacts
export const bulkDeleteContacts = async (uids: string[]): Promise<void> => {
  await axiosJSONInstance.post('/merchants/contacts/bulk-delete', { uids });
};

// Fetch Contact Import Template
export const fetchContactImportTemplate = async (): Promise<Blob> => {
  const response = await axiosJSONInstance.get('/merchants/contacts/import/template', {
    responseType: 'blob',
  });
  return response.data;
};

// Preview Contact Import
export const previewContactImport = async (
  file: File,
): Promise<ContactImportPreviewResponse> => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await axiosJSONInstance.post('/merchants/contacts/import/preview', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

// Commit Contact Import
export const commitContactImport = async (
  file: File,
): Promise<ContactImportCommitResponse> => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await axiosJSONInstance.post('/merchants/contacts/import/commit', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};
